<script>
export default {
    props: {
        text: String,
    }
}
</script>

<template>
    <w-btn-icon
        v-if="text"
        icon="mdi-information-outline"
        color="blue"
        html
        :tooltip="text"
    />
</template>

<style scoped>

</style>